// src/components/Copyright.js
import React from "react";

export default function Copyright() {
    return (
        <footer className="bg-gray-800 text-center lg:text-left">
            <div className="text-white text-center p-4">
                @2022 Podconn Ltd.
            </div>
        </footer>
    );
}


// WEBPACK FOOTER //
// ./src/components/Copyright.js